import { uniq } from 'lodash'

// The standard chrome for echarts' native tooltip, as designed on the Trends
// page. Callers layer behavior on top (trigger, formatter, valueFormatter);
// series-level usages omit trigger since it only applies at the option root.
// Prefer valueFormatter over a hand-built formatter string: echarts escapes
// its default content, but a custom formatter interpolating user-controlled
// strings must escape them itself.
export const nativeTooltip = (overrides = {}) => ({
  borderColor: 'var(--color-border)',
  borderRadius: 16,
  borderWidth: 1,
  textStyle: { color: 'var(--color-text)' },
  ...overrides,
})

export const getTickValues = (data, key) => {
  let skipNum = 0

  if (data.length > 50) {
    skipNum = 8
  } else if (data.length > 25) {
    skipNum = 5
  } else if (data.length > 15) {
    skipNum = 3
  } else {
    skipNum = 1
  }

  return uniq(data.map((d) => d[key])).filter((item, i) => i % skipNum === 0) || []
}
